export default {
    accountType: {
        business: 'Business',
        enterprise: 'Enterprise',
        label: 'Account Type',
        personal: 'Personal',
    },
    agreeRequired: 'You must agree',
    email: 'Email',
    employeesMoreThanZero: 'Number of employees must be more than 0',
    food: {
        donuts: 'Donuts',
        label: 'Favorite Food',
        pasta: 'Pasta',
        pizza: 'Pizza',
        ramen: 'Ramen',
        select: 'Select your favorite food(s)',
        sushi: 'Sushi',
        tempura: 'Tempura',
    },
    information: {
        message:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        title: 'Lorem ipsum dolor',
    },
    notifications: 'Notifications',
    passwordConfirmationRequired: 'Password confirmation is required',
    passwordMismatch: 'Passwords do not match',
    phone: 'Phone',
    select: 'Select',
    sideDishes: {
        frenchFries: 'French Fries',
        label: 'Favorite Side Dishes',
        salad: 'Salad',
        select: 'Select your favorite side(s)',
    },
    subscription: {
        label: 'Subscription',
        lifetime: 'Lifetime',
        monthly: 'Monthly',
        yearly: 'Yearly',
    },
};
